export enum AnnouncementQueryKeys {
	getAnnouncement = 'getAnnouncement',
	getAnnouncementById = 'getAnnouncementById',
}

export enum AnnouncementMutationKeys {
	createAnnouncement = 'createAnnouncement',
	updateAnnouncement = 'updateAnnouncement',
	deleteAnnouncement = 'deleteAnnouncement',
}
